import useReveal from "@/hooks/useReveal";

const defaultFears = [
  "Will I lose time with my child?",
  "Can I trust my attorney to fight for me?",
  "What if the judge doesn't see my side?",
  "What if I lose?",
];

export default function FearSection({
  fears = defaultFears,
  eyebrow = "The Quiet Hours",
  heading,
  closingLine,
} = {}) {
  useReveal();
  const defaultHeading = (
    <>
      Do any of these questions{" "}
      <span className="italic font-medium">keep you up at night?</span>
    </>
  );
  return (
    <section
      data-testid="fear-section"
      className="relative bg-ink text-paper py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative max-w-[1320px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-10 h-px bg-teal" />
              <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-teal">
                {eyebrow}
              </p>
            </div>
            <h2 className="font-display text-[40px] md:text-[56px] lg:text-[64px] leading-[1.02] tracking-tight">
              {heading || defaultHeading}
            </h2>
          </div>

          <div className="lg:col-span-7 reveal">
            <ul className="divide-y divide-paper/15 border-y border-paper/15">
              {fears.map((q, i) => (
                <li
                  key={q}
                  data-testid={`fear-item-${i}`}
                  className="group flex items-baseline gap-6 py-7 md:py-8"
                >
                  <span className="font-mono text-[11px] tracking-[0.24em] text-teal/80 w-8 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <p className="font-display text-2xl md:text-[32px] leading-snug text-paper italic transition-colors group-hover:text-teal-light">
                    {q}
                  </p>
                </li>
              ))}
            </ul>

            <p className="mt-10 max-w-[58ch] text-paper/80 text-[17px] leading-[1.75]">
              {closingLine ||
                "If you're asking these questions, you're not alone. And you're exactly who this firm was built for."}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
